{
	"showButtonTitle": "Tonen",
	"hideButtonTitle": "Verbergen"
}
